var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.STRATEGY_SOURCE_ROUTE_LIST },
      }),
      _c(
        "div",
        { staticClass: "mt16", staticStyle: { width: "400px" } },
        [
          _c("el-link", { attrs: { type: "warning", underline: false } }, [
            _vm._v(_vm._s(_vm.$t("SettingOrderSourceStrategySourcing.title"))),
          ]),
          _c(
            "draggable",
            {
              staticClass: "mt16",
              attrs: {
                "ghost-class": "ghost",
                "chosen-class": "chosen",
                "force-fallback": "true",
                group: "people",
                animation: "300",
                filter: ".forbid",
                draggable: ".item",
                handle: ".svg-icon",
              },
              on: { end: _vm.onEnd },
              model: {
                value: _vm.list,
                callback: function ($$v) {
                  _vm.list = $$v
                },
                expression: "list",
              },
            },
            _vm._l(_vm.list, function (item, index) {
              return _c("div", { key: index, staticClass: "item" }, [
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "SettingOrderSourceStrategySourcing." + item.code
                        )
                      ) +
                      " "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "item-right" },
                  [
                    _c("el-switch", {
                      staticClass: "switch",
                      attrs: { "active-value": 1, "inactive-value": 0 },
                      on: {
                        change: function ($event) {
                          return _vm.onChange(item, index)
                        },
                      },
                      model: {
                        value: item.status,
                        callback: function ($$v) {
                          _vm.$set(item, "status", $$v)
                        },
                        expression: "item.status",
                      },
                    }),
                    _c("svg-icon", { attrs: { "icon-class": "pointer" } }),
                  ],
                  1
                ),
              ])
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }